import { ICoreContext } from '@msdyn365-commerce/core';
import React, { useState } from 'react';
import { IOrderDetailResponse } from '../../../actions/order-details/get-order-details.action';
import { ILocalizationState } from '../../../states/localization-state';
import { isMobileView } from '../../../utilities';
import { IOrderDetailsViewProps } from '../order-details';
import { IOrderDetailsResources } from '../order-details.props.autogenerated';
import AddressInformationSection from './address-information-section';
import DocumentsTable from './documents-table';
import GeneralInformationSection from './general-information-section';
import OrderItems from './order-items-table';

interface OrderInformationProps {
    orderDetails: IOrderDetailResponse;
    resources: IOrderDetailsResources;
    context: ICoreContext;
    props: IOrderDetailsViewProps;
    localizationState: ILocalizationState;
}

const OrderInformation: React.FC<OrderInformationProps> = ({ orderDetails, context, resources, props, localizationState }) => {
    const isMobile = isMobileView(context);
    const [isGenInfoCollapsed, setIsGenInfoCollapsed] = useState<boolean>(isMobile);
    const [isAddrInfoCollapsed, setIsAddrInfoCollapsed] = useState<boolean>(isMobile);

    const renderGeneralInfo = (
        context: ICoreContext,
        orderDetails: IOrderDetailResponse,
        resources: IOrderDetailsResources,
        localizationState: ILocalizationState
    ) => (
        <GeneralInformationSection
            context={context}
            orderDetails={orderDetails}
            resources={resources}
            localizationState={localizationState}
        />
    );

    const renderAddressInfo = (orderDetails: IOrderDetailResponse, resources: IOrderDetailsResources) => (
        <AddressInformationSection orderDetails={orderDetails} resources={resources} />
    );

    return (
        <>
            {isMobile ? (
                <>
                    <div className='msc-section-box'>
                        <h3
                            className={`msc-section-box__title ${isGenInfoCollapsed ? 'collapsed' : ''}`}
                            onClick={() => setIsGenInfoCollapsed(state => !state)}
                        >
                            {resources.orderDetailsGeneralInformationSectionHeading}
                        </h3>
                        {!isGenInfoCollapsed && (
                            <div className='msc-section-box__body'>
                                {renderGeneralInfo(context, orderDetails, resources, localizationState)}
                            </div>
                        )}
                    </div>

                    <div className='msc-section-box address-information'>
                        <h3
                            className={`msc-section-box__title ${isAddrInfoCollapsed ? 'collapsed' : ''}`}
                            onClick={() => setIsAddrInfoCollapsed(state => !state)}
                        >
                            {resources?.orderDetailsAddressInformationSectionHeading}
                        </h3>
                        {!isAddrInfoCollapsed && <div className='msc-section-box__body'>{renderAddressInfo(orderDetails, resources)}</div>}
                    </div>
                </>
            ) : (
                <div className='msc-section-box'>
                    <div className='msc-section-box__body'>
                        <div className='row'>
                            <div className='msc-section-box__general-information-wrapper col-lg-7'>
                                <h3 className={`msc-section-box__title ${isGenInfoCollapsed ? 'collapsed' : ''}`}>
                                    {resources.orderDetailsGeneralInformationSectionHeading}
                                </h3>
                                {renderGeneralInfo(context, orderDetails, resources, localizationState)}
                            </div>
                            <div className='col-lg-5 address-information'>
                                <h3 className={`msc-section-box__title ${isAddrInfoCollapsed ? 'collapsed' : ''}`}>
                                    {resources?.orderDetailsAddressInformationSectionHeading}
                                </h3>
                                {renderAddressInfo(orderDetails, resources)}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <OrderItems
                props={props}
                context={context}
                orderDetails={orderDetails}
                resources={resources}
                localizationState={localizationState}
            ></OrderItems>

            <DocumentsTable
                context={context}
                orderDetails={orderDetails}
                resources={resources}
                localizationState={localizationState}
            ></DocumentsTable>
        </>
    );
};

export default OrderInformation;
